export default __webpack_public_path__ + "static/media/11.6b502f0e.png";